import SendPaymentRequestDialog from './SendPaymentRequestDialog'

export * from './SendPaymentRequestDialog'
export default SendPaymentRequestDialog
